module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }